import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import StoreLayout from './components/layout/StoreLayout';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import WishlistPage from './pages/WishlistPage';
import ComparePage from './pages/ComparePage';
import LoginRegisterPage from './pages/LoginRegisterPage';
import AccountPage from './pages/AccountPage';
import AboutUsPage from './pages/AboutUsPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';

// Initialize store JavaScript after component mounts
const initializeStoreJS = () => {
  // This will be called after the component mounts to initialize jQuery plugins
  // We'll handle this with useEffect hooks in individual components
};

const StoreApp = () => {
  useEffect(() => {
    // Initialize any store-specific JavaScript here
    initializeStoreJS();
  }, []);

  return (
    <div className="body-wrapper">
      <StoreLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/:category" element={<ShopPage />} />
          <Route path="/product/:slug" element={<ProductDetailsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/login-register" element={<LoginRegisterPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/orders/:id" element={<AccountPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </StoreLayout>
    </div>
  );
};

export default StoreApp;

